import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, RequireAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Realizations from "@/pages/admin/Realizations";
import Quotes from "@/pages/admin/Quotes";
import QuoteDetail from "@/pages/admin/QuoteDetail";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminServices from "@/pages/admin/AdminServices";
import SiteSettings from "@/pages/admin/SiteSettings";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="realisations" element={<Realizations />} />
            <Route path="demandes" element={<Quotes />} />
            <Route path="demandes/:id" element={<QuoteDetail />} />
            <Route path="avis" element={<AdminReviews />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="site" element={<SiteSettings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
